import React from 'react';

import { Box, HStack, HStackProps } from '@rbilabs/universal-components';

import { DELIVERY_PROGRESS_COLOR } from './constants';

const barMargin = '45px';
const ProgressBarLine = HStack.withConfig({
  position: 'absolute',
  top: barMargin,
  left: barMargin,
  right: barMargin,
  height: '$1',
});

const CompleteSegment = Box.withConfig({
  backgroundColor: DELIVERY_PROGRESS_COLOR,
});

const RemainingSegment = Box.withConfig<{ whiteVariant?: boolean }>(p => ({
  backgroundColor: p.whiteVariant ? 'white' : Styles.color.grey.five,
}));

interface ProgressBarProps {
  percentComplete: number;
  styles?: HStackProps;
  whiteVariant?: boolean;
}

const ProgressBar: React.FC<React.PropsWithChildren<ProgressBarProps>> = ({
  percentComplete = 0,
  styles = {},
  whiteVariant,
}) => {
  return (
    <ProgressBarLine {...styles}>
      <CompleteSegment width={`${percentComplete}%`} />
      <RemainingSegment width={`${100 - percentComplete}%`} whiteVariant={whiteVariant} />
    </ProgressBarLine>
  );
};

export default ProgressBar;
